import { IHttpApi } from '@cian/http-api';

import {
  TCianApiSiteV1ConvertJsonQueryToSeoUrlResponse,
  fetchCianApiSiteV1ConvertJsonQueryToSeoUrl,
} from 'shared/repositories/monolith-python/cian-api/site/v1/convert-json-query-to-seo-url';

import { IJsonQuery, jq } from '../json_query';

type ConvertJsonQueriesToSeoUrlsOptions = {
  httpApi: IHttpApi;
  jsonQuery: IJsonQuery;
  subdomain: string;
};

export function convertJsonQueriesToSeoUrls({
  httpApi,
  jsonQuery,
  subdomain,
}: ConvertJsonQueriesToSeoUrlsOptions): Promise<string[]> {
  // ЧПУ в пагинации может быть только для первых двух страниц выдачи
  const jsonQueries = [1, 2].map(pageNumber => jq(jsonQuery).setPageNumber(pageNumber));

  return fetchCianApiSiteV1ConvertJsonQueryToSeoUrl<
    TCianApiSiteV1ConvertJsonQueryToSeoUrlResponse,
    TCianApiSiteV1ConvertJsonQueryToSeoUrlResponse
  >({
    httpApi,
    parameters: {
      jsonQueries,
    },
    config: {
      subdomain,
    },
  }).then(({ response }) => {
    if (response.status === 'ok') {
      return response.data.urls || [];
    }

    return [];
  });
}
